module.exports = __webpack_public_path__ + "img/report-icon.c514a775.png";